<template>
  <b-modal
    v-model="showModal"
    title="Session Timeout Warning"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :hide-header-close="true"
    centered
  >
    <div class="text-center">
      <b-icon icon="exclamation-triangle" variant="warning" font-scale="3" class="mb-3"></b-icon>
      <p class="mb-3">
        You will be logged out in <strong class="text-danger fs-4">{{ timeLeft }}</strong> seconds due to inactivity.
      </p>
    </div>
    
    <template #modal-footer>
      <b-button class="akkurate-grey-btn border-0 btn-size ms-2" @click="handleStayLoggedIn">
        Stay Logged In
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    isIdle: {
      type: Boolean,
      default: false
    },
    timeLeft: {
      type: Number,
      default: 0
    },
    stayLoggedIn: {
      type: Function,
      required: true
    }
  },
  computed: {
    showModal: {
      get() {
        return this.isIdle
      },
      set(value) {
        // Prevent closing the modal unless user clicks "Stay Logged In"
        if (!value && this.isIdle) {
          return
        }
      }
    }
  },
  methods: {
    handleStayLoggedIn() {
      this.stayLoggedIn()
    }
  }
}
</script>